var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.js
var index_exports = {};
__export(index_exports, {
  Accordion: () => Accordion,
  AccordionDetails: () => AccordionDetails,
  AccordionSummary: () => AccordionSummary,
  AttributeList: () => AttributeList,
  Button: () => Button,
  CataloguePageDescription: () => CataloguePageDescription,
  CataloguePageTitle: () => CataloguePageTitle,
  DataGrid: () => DataGrid,
  Dropdown: () => Dropdown,
  HeroImage: () => HeroImage,
  ImageRow: () => ImageRow,
  ItemDescription: () => ItemDescription,
  ItemHeader: () => ItemHeader,
  NavigationBar: () => NavigationBar,
  NavigationDrawer: () => NavigationDrawer,
  PipelineBlock: () => PipelineBlock,
  PipelineStatus: () => PipelineStatus,
  ProgressBar: () => ProgressBar,
  ProvideTheme: () => ProvideTheme,
  RapidsAgentDarkTheme: () => RapidsAgentDarkTheme,
  RapidsAgentTheme: () => RapidsAgentTheme,
  RapidsChallengeTheme: () => RapidsChallengeTheme,
  SectionDescription: () => SectionDescription,
  SectionHeader: () => SectionHeader,
  TabPane: () => TabPane,
  Tabs: () => Tabs,
  TabsContainer: () => TabsContainer,
  TextField: () => TextField,
  ToggleIcon: () => ToggleIcon
});
module.exports = __toCommonJS(index_exports);

// src/Themes/rapids-agent/rapids-agent.js
var import_styles = require("@mui/material/styles");
var import_utils = require("@mui/utils");
var defaultThemeOptions = {
  colorSchemes: {
    dark: false
  },
  palette: {
    mode: "light",
    primary: {
      main: "#FFAF13",
      //light: '#FFAF13',
      dark: "#E09A11",
      contrastText: "#000"
    },
    secondary: {
      main: "#003E65",
      //light: '#FFF',
      dark: "#001B2C",
      contrastText: "#FFF"
    },
    error: {
      main: "#dc3545"
    },
    warning: {
      main: "#dc3545"
    },
    info: {
      main: "#0c89d7"
    },
    success: {
      main: "#28a745"
    }
  },
  typography: {
    fontFamily: '"Source Sans Pro"',
    h1: {
      fontSize: "1.875rem",
      fontWeight: "bold",
      letterSpacing: "0.1rem"
    },
    h2: {
      fontSize: "1.625rem",
      fontWeight: "normal",
      letterSpacing: "0.04rem"
    },
    h3: {
      fontSize: "1.25rem",
      color: "grey"
    },
    h4: {
      fontSize: "1.35rem",
      fontWeight: "normal",
      letterSpacing: "0.04rem"
    },
    h5: {
      fontSize: "1.25rem"
    },
    h6: {
      fontSize: "1.16rem"
    },
    subtitle1: {},
    subtitle2: {},
    body1: {
      fontSize: "1rem"
    },
    body2: {
      fontSize: "0.75rem"
    },
    button: {},
    caption: {},
    overline: {}
  }
};
var darkAgentThemeOptions = {
  colorSchemes: {
    dark: true
  },
  palette: {
    mode: "dark",
    text: {
      primary: "#fff",
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)"
    },
    primary: {
      main: "#FFAF13",
      //light: '#FFAF13',
      dark: "#E09A11",
      contrastText: "#000"
    },
    secondary: {
      main: "#003E65",
      //light: '#FFF',
      dark: "#001B2C",
      contrastText: "#FFF"
    },
    error: {
      main: "#dc3545"
    },
    warning: {
      main: "#dc3545"
    },
    info: {
      main: "#0c89d7"
    },
    success: {
      main: "#28a745"
    }
  }
};
var challengeThemeOptions = {
  palette: {
    primary: {
      main: "#9FAAC5",
      //light: '#FFAF13',
      dark: "#382962",
      contrastText: "#000"
    },
    secondary: {
      main: "#382962",
      //light: '#FFF',
      dark: "#001B2C",
      contrastText: "#FFF"
    },
    error: {
      main: "#dc3545"
    },
    warning: {
      main: "#dc3545"
    },
    info: {
      main: "#0c89d7"
    },
    success: {
      main: "#28a745"
    }
  }
};
var RapidsAgentTheme = (0, import_styles.createTheme)(defaultThemeOptions);
var RapidsAgentDarkTheme = (0, import_styles.createTheme)((0, import_utils.deepmerge)(defaultThemeOptions, darkAgentThemeOptions));
var RapidsChallengeTheme = (0, import_styles.createTheme)((0, import_utils.deepmerge)(defaultThemeOptions, challengeThemeOptions));

// src/Accordion/Accordion.js
var import_prop_types = __toESM(require("prop-types"));
var import_Typography = __toESM(require("@mui/material/Typography"));
var import_Accordion = __toESM(require("@mui/material/Accordion"));

// src/utils.js
var componentSpread = (components26 = [], defaultStyles26 = {}, overrides = {}, props = {}) => {
  let compOverrides = {};
  for (let i = 0; i < components26.length; i++) {
    let key = components26[i];
    compOverrides[key] = {
      props: overrides[key]?.props,
      styles: { ...defaultStyles26[key], ...overrides[key]?.styles }
    };
  }
  compOverrides.root = compOverrides.root || {};
  compOverrides.root.styles = { ...defaultStyles26?.root, ...props?.style, ...props?.sx, ...overrides?.root?.styles };
  delete props.style;
  delete props.sx;
  return compOverrides;
};
var modifyName = (oldName, splitChar = "_") => {
  let splitName = oldName.split(splitChar);
  let newName = "";
  for (let i = 0; i < splitName.length; i++) {
    newName += splitName[i].charAt(0).toUpperCase() + splitName[i].slice(1);
    newName += i === splitName.length - 1 ? "" : " ";
  }
  return newName;
};

// src/Accordion/Accordion.js
var import_jsx_runtime = require("react/jsx-runtime");
var defaultStyles = {
  root: {
    backgroundColor: "rgba(0,0,0,0)",
    boxShadow: "none",
    marginTop: "0px",
    marginBottom: "4px",
    "&:before": {
      display: "none"
    },
    "&.Mui-expanded": {
      marginTop: "0px",
      marginBottom: "4px"
    }
  }
};
var components = [
  "root"
];
var Accordion = ({ children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components, defaultStyles, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_Accordion.default,
    {
      sx: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
Accordion.getComponents = () => {
  return components;
};
Accordion.propTypes = {
  /**
   * Children for the primary element
   */
  children: import_prop_types.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types.default.objectOf(
    import_prop_types.default.shape({
      props: import_prop_types.default.any,
      styles: import_prop_types.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types.default.any
};

// src/AccordionSummary/AccordionSummary.js
var import_prop_types2 = __toESM(require("prop-types"));
var import_Typography2 = __toESM(require("@mui/material/Typography"));
var import_AccordionSummary = __toESM(require("@mui/material/AccordionSummary"));
var import_PlayArrow = __toESM(require("@mui/icons-material/PlayArrow"));
var import_jsx_runtime2 = require("react/jsx-runtime");
var defaultStyles2 = {
  root: {
    flexDirection: "row-reverse",
    backgroundColor: "white",
    paddingLeft: "5px"
  },
  primary: {
    border: "1px solid lightgrey",
    minHeight: "50px",
    maxHeight: "50px",
    margin: "0",
    "&.Mui-expanded": {
      minHeight: "50px",
      maxHeight: "50px",
      margin: "0"
    }
  },
  secondary: {
    border: "1px solid #DDDDDD",
    borderRadius: "4px",
    minHeight: "40px",
    maxHeight: "40px",
    margin: "0",
    "& .MuiAccordionSummary-expandIconWrapper > svg": {
      fontSize: "1.2rem"
    },
    "&.Mui-expanded": {
      minHeight: "40px",
      maxHeight: "40px",
      margin: "0"
    }
  },
  expandIcon: {
    transform: "rotate(90deg)",
    fill: "black",
    marginTop: "-3px",
    marginX: "8px"
  }
};
var components2 = [
  "root",
  "primary",
  "secondary",
  "expandIcon"
];
var AccordionSummary = ({ variant = "primary", children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components2, defaultStyles2, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    import_AccordionSummary.default,
    {
      sx: { ...compOverrides.root.styles, ...compOverrides[variant]?.styles },
      expandIcon: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_PlayArrow.default, { sx: compOverrides.expandIcon.styles, ...compOverrides.expandIcon.props }),
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
AccordionSummary.getComponents = () => {
  return components2;
};
AccordionSummary.propTypes = {
  /**
   * variant for this component. 'primary' or 'secondary'
   */
  variant: import_prop_types2.default.string,
  /**
   * Children for the primary element
   */
  children: import_prop_types2.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types2.default.objectOf(
    import_prop_types2.default.shape({
      props: import_prop_types2.default.any,
      styles: import_prop_types2.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types2.default.any
};

// src/AccordionDetails/AccordionDetails.js
var import_prop_types3 = __toESM(require("prop-types"));
var import_Typography3 = __toESM(require("@mui/material/Typography"));
var import_AccordionDetails = __toESM(require("@mui/material/AccordionDetails"));
var import_jsx_runtime3 = require("react/jsx-runtime");
var defaultStyles3 = {
  root: {
    paddingTop: "30px",
    border: "1px solid lightgrey",
    backgroundColor: "#F9F9FA"
  },
  primary: {},
  secondary: {
    paddingTop: "10px",
    paddingLeft: "calc(15px + 5%)",
    paddingRight: "calc(15px + 5%)",
    backgroundColor: "rgba(0,0,0,0)"
  }
};
var components3 = [
  "root",
  "primary",
  "secondary"
];
var AccordionDetails = ({ variant = "primary", children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components3, defaultStyles3, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    import_AccordionDetails.default,
    {
      sx: { ...compOverrides.root.styles, ...compOverrides[variant]?.styles },
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
AccordionDetails.getComponents = () => {
  return components3;
};
AccordionDetails.propTypes = {
  /**
   * variant for this component. 'primary' or 'secondary'
   */
  variant: import_prop_types3.default.string,
  /**
   * Children for the primary element
   */
  children: import_prop_types3.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types3.default.objectOf(
    import_prop_types3.default.shape({
      props: import_prop_types3.default.any,
      styles: import_prop_types3.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types3.default.any
};

// src/Button/Button.js
var import_prop_types4 = __toESM(require("prop-types"));
var import_material = require("@mui/material");
var import_jsx_runtime4 = require("react/jsx-runtime");
var defaultStyles4 = {
  root: {
    textTransform: "none"
    // color: 'inherit',
    /*backgroundColor: '#FFAF13',
    color: 'black',
    '&:hover': {
      color:'black',
      backgroundColor: 'white',
      border: '1px #FFAF13 solid',
    }*/
  }
};
var components4 = [
  "root"
];
var Button = ({ variant = "contained", children, overrides = {}, ...props }) => {
  defaultStyles4.root.minWidth = variant === "text" && "0px";
  defaultStyles4.root.borderWidth = variant === "outlined" && "3px";
  const compOverrides = componentSpread(components4, defaultStyles4, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    import_material.Button,
    {
      variant,
      disableRipple: true,
      ...props,
      sx: compOverrides.root.styles,
      ...compOverrides.root.props,
      children
    }
  );
};
Button.getComponents = () => {
  return components4;
};
Button.propTypes = {
  /**
   * Variant type for this button
   */
  variant: import_prop_types4.default.string,
  /**
   * Children for the primary element
   */
  children: import_prop_types4.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types4.default.objectOf(
    import_prop_types4.default.shape({
      props: import_prop_types4.default.any,
      styles: import_prop_types4.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types4.default.any
};

// src/HeroImage/HeroImage.js
var import_prop_types5 = __toESM(require("prop-types"));
var import_jsx_runtime5 = require("react/jsx-runtime");
var defaultStyles5 = {
  root: {
    width: "100%",
    minHeight: "500px",
    color: "white",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  }
};
var components5 = [
  "root"
];
var HeroImage = ({ bgImage, dark, children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components5, defaultStyles5, overrides, props);
  let image = dark ? `linear-gradient(rgba(0, 0, 0, 0.7),rgba(0, 0, 0, 0.5)), url(${bgImage})` : `url(${bgImage})`;
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    "div",
    {
      style: { backgroundImage: bgImage ? image : "none", ...compOverrides.root.styles },
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
HeroImage.getComponents = () => {
  return components5;
};
HeroImage.propTypes = {
  /**
   * Url for the image to display
   */
  bgImage: import_prop_types5.default.string,
  /**
   * True to darken the hero image
   */
  dark: import_prop_types5.default.bool,
  /**
   * Children for the primary element
   */
  children: import_prop_types5.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types5.default.objectOf(
    import_prop_types5.default.shape({
      props: import_prop_types5.default.any,
      styles: import_prop_types5.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types5.default.any
};

// src/CataloguePageTitle/CataloguePageTitle.js
var import_prop_types6 = __toESM(require("prop-types"));
var import_Typography4 = __toESM(require("@mui/material/Typography"));
var import_jsx_runtime6 = require("react/jsx-runtime");
var defaultStyles6 = {
  root: {}
};
var components6 = [
  "root"
];
var CataloguePageTitle = ({ children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components6, defaultStyles6, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    import_Typography4.default,
    {
      variant: "h1",
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
CataloguePageTitle.getComponents = () => {
  return components6;
};
CataloguePageTitle.propTypes = {
  /**
   * Children for the primary element
   */
  children: import_prop_types6.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types6.default.objectOf(
    import_prop_types6.default.shape({
      props: import_prop_types6.default.any,
      styles: import_prop_types6.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types6.default.any
};

// src/CataloguePageDescription/CataloguePageDescription.js
var import_prop_types7 = __toESM(require("prop-types"));
var import_Typography5 = __toESM(require("@mui/material/Typography"));
var import_jsx_runtime7 = require("react/jsx-runtime");
var defaultStyles7 = {
  root: {}
};
var components7 = [
  "root"
];
var CataloguePageDescription = ({ children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components7, defaultStyles7, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    import_Typography5.default,
    {
      variant: "h2",
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
CataloguePageDescription.getComponents = () => {
  return components7;
};
CataloguePageDescription.propTypes = {
  /**
   * Children for the primary element
   */
  children: import_prop_types7.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types7.default.objectOf(
    import_prop_types7.default.shape({
      props: import_prop_types7.default.any,
      styles: import_prop_types7.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types7.default.any
};

// src/DataGrid/DataGrid.js
var import_prop_types8 = __toESM(require("prop-types"));
var import_x_data_grid = require("@mui/x-data-grid");
var import_Box = __toESM(require("@mui/material/Box"));
var import_jsx_runtime8 = require("react/jsx-runtime");
var defaultStyles8 = {
  root: {},
  box: {
    minHeight: 20,
    maxHeight: 600,
    width: "100%"
  },
  grid: {
    minHeight: 20,
    maxHeight: 640,
    width: "100%"
  }
};
var components8 = [
  "root",
  "box",
  "grid"
];
var DataGrid = ({
  rows,
  columns,
  checkboxes = false,
  is_loading = false,
  with_toolbar = false,
  children = {},
  overrides = {},
  ...props
}) => {
  const compOverrides = componentSpread(components8, defaultStyles8, overrides, props);
  function CustomToolbar() {
    return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(import_x_data_grid.GridToolbarContainer, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_x_data_grid.GridToolbarColumnsButton, {}),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_x_data_grid.GridToolbarFilterButton, {}),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
        import_x_data_grid.GridToolbarDensitySelector,
        {
          slotProps: { tooltip: { title: "Change density" } }
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_Box.default, { sx: { flexGrow: 1 } }),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
        import_x_data_grid.GridToolbarExport,
        {
          slotProps: {
            tooltip: { title: "Export data" },
            button: { variant: "outlined" }
          }
        }
      )
    ] });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
    "div",
    {
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      children: /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
        import_Box.default,
        {
          sx: compOverrides.box.styles,
          ...compOverrides.box.props,
          children: [
            with_toolbar && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
              import_x_data_grid.DataGrid,
              {
                rows,
                columns,
                checkboxSelection: checkboxes,
                loading: is_loading,
                slots: {
                  toolbar: CustomToolbar
                },
                slotProps: {
                  loadingOverlay: {
                    variant: "linear-progress",
                    noRowsVariant: "skeleton"
                  }
                },
                ...props,
                sx: compOverrides.grid.styles,
                ...compOverrides.grid.props
              }
            ),
            !with_toolbar && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
              import_x_data_grid.DataGrid,
              {
                rows,
                columns,
                checkboxSelection: checkboxes,
                loading: is_loading,
                slotProps: {
                  loadingOverlay: {
                    variant: "linear-progress",
                    noRowsVariant: "skeleton"
                  }
                },
                ...props,
                sx: compOverrides.grid.styles,
                ...compOverrides.grid.props
              }
            )
          ]
        }
      )
    }
  );
};
DataGrid.getComponents = () => {
  return components8;
};
DataGrid.propTypes = {
  /**
   * Rows
   */
  rows: import_prop_types8.default.arrayOf(import_prop_types8.object).isRequired,
  /**
   * Columns
   */
  columns: import_prop_types8.default.arrayOf(import_prop_types8.default.oneOfType([import_prop_types8.default.string, import_prop_types8.default.object])).isRequired,
  /**
   * Include optional selection checkboxes
   */
  checkboxes: import_prop_types8.default.bool,
  /**
   * Optional state is currently loading
   */
  is_loading: import_prop_types8.default.bool,
  /**
   * Optional toolbar
   */
  with_toolbar: import_prop_types8.default.bool,
  /**
   * Children for the primary element
   */
  children: import_prop_types8.default.any,
  /**
   * Any overrides to be propagated to the respective component.
   */
  overrides: import_prop_types8.default.objectOf(
    import_prop_types8.default.shape({
      props: import_prop_types8.default.any,
      styles: import_prop_types8.default.any
    })
  ),
  /**
   * Any additional properties to be propagated to the primary element
   */
  props: import_prop_types8.default.any
};

// src/Dropdown/Dropdown.js
var import_prop_types9 = __toESM(require("prop-types"));
var import_react = require("react");
var import_mui = require("tss-react/mui");
var import_Menu = __toESM(require("@mui/material/Menu"));
var import_md = require("react-icons/md");
var import_jsx_runtime9 = require("react/jsx-runtime");
var defaultStyles9 = {
  root: {},
  button: {},
  arrow: {
    fontSize: "1.2rem",
    margin: "0 -5px 0 2px"
  },
  menu: {
    border: "1px solid #d3d4d5",
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.06)"
  }
};
var components9 = [
  "root",
  "button",
  "arrow",
  "menu"
];
var Dropdown = ({ title = "Open Menu", noArrow, children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components9, defaultStyles9, overrides, props);
  const [anchorEl, setAnchorEl] = (0, import_react.useState)(null);
  const handleClick = (event) => {
    if (props.onClick) {
      props.onClick(event);
    }
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const arrow = !noArrow && /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
    import_md.MdArrowDropDown,
    {
      style: compOverrides.arrow.styles,
      ...compOverrides.arrow.props
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
    "div",
    {
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
          Button,
          {
            "aria-controls": "customized-menu",
            "aria-haspopup": "true",
            ...props,
            onClick: handleClick,
            overrides: { root: { styles: compOverrides.button.styles, props: compOverrides.button.props } },
            children: [
              title,
              " ",
              arrow
            ]
          }
        ),
        children && /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
          import_Menu.default,
          {
            anchorEl,
            keepMounted: true,
            open: Boolean(anchorEl),
            onClose: handleClose,
            elevation: 0,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "right"
            },
            slotProps: {
              paper: {
                sx: compOverrides.menu.styles,
                ...compOverrides.menu.props
              }
            },
            children
          }
        )
      ]
    }
  );
};
Dropdown.getComponents = () => {
  return components9;
};
Dropdown.propTypes = {
  /**
   * Button text
   */
  title: import_prop_types9.default.oneOfType([import_prop_types9.default.string, import_prop_types9.default.node]),
  /**
   * Children for the primary element, in this case probably a list of menu options
   */
  children: import_prop_types9.default.node,
  /**
   * Any overrides to be propagated to the respective component.
   */
  overrides: import_prop_types9.default.objectOf(
    import_prop_types9.default.shape({
      props: import_prop_types9.default.any,
      styles: import_prop_types9.default.any
    })
  ),
  /**
   * Any additional properties to be propagated to the primary element
   */
  props: import_prop_types9.default.any
};

// src/AttributeList/AttributeList.js
var import_prop_types10 = __toESM(require("prop-types"));
var import_Typography6 = __toESM(require("@mui/material/Typography"));
var import_jsx_runtime10 = require("react/jsx-runtime");
var defaultStyles10 = {
  root: {},
  row: {},
  label: {},
  value: {}
};
var components10 = [
  "root",
  "row",
  "label",
  "value"
];
var AttributeList = ({
  dataAttributes = {},
  modifyLabel = false,
  ignoreValue = false,
  beforeElement = /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(import_jsx_runtime10.Fragment, {}),
  overrides = {},
  ...props
}) => {
  const compOverrides = componentSpread(components10, defaultStyles10, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
    import_Typography6.default,
    {
      component: "span",
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children: Object.keys(dataAttributes).map((attributeKey, index) => {
        let label = dataAttributes[attributeKey]?.label || attributeKey;
        let value = "";
        let before = dataAttributes[attributeKey]?.before || beforeElement;
        if (!ignoreValue) {
          value = dataAttributes[attributeKey]?.value || dataAttributes[attributeKey];
        }
        if (!ignoreValue && (!label || !value)) {
          return;
        }
        if (modifyLabel) {
          label = modifyName(label);
        }
        return /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { style: compOverrides.row.styles, ...compOverrides.row.props, children: [
          before,
          /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("b", { style: compOverrides.label.styles, ...compOverrides.label.props, children: [
            label,
            value && /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(import_jsx_runtime10.Fragment, { children: ":" })
          ] }),
          "\xA0",
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { style: compOverrides.value.styles, ...compOverrides.value.props, children: value })
        ] }, label);
      })
    }
  );
};
AttributeList.getComponents = () => {
  return components10;
};
AttributeList.propTypes = {
  /**
   * Variant type for this AttributeList
   */
  dataAttributes: import_prop_types10.default.objectOf(import_prop_types10.default.oneOfType([import_prop_types10.default.string, import_prop_types10.default.object])),
  /**
   * Children for the primary element
   */
  modifyLabel: import_prop_types10.default.bool,
  /**
   * Any overrides to be propogated to the respective component.
   */
  overrides: import_prop_types10.default.objectOf(
    import_prop_types10.default.shape({
      props: import_prop_types10.default.any,
      styles: import_prop_types10.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types10.default.any
};

// src/NavigationBar/NavigationBar.js
var import_prop_types11 = __toESM(require("prop-types"));
var import_material2 = require("@mui/material");
var import_material3 = require("@mui/material");
var import_jsx_runtime11 = require("react/jsx-runtime");
var defaultStyles11 = {
  root: {
    position: "relative !important",
    width: "100%"
  },
  toolbar: {
    height: "100%",
    minHeight: "unset !important",
    padding: 0
  }
};
var components11 = [
  "root",
  "toolbar"
];
var NavigationBar = ({ backgroundColor = "#001B2C", children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components11, defaultStyles11, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
    import_material2.AppBar,
    {
      position: "static",
      sx: { background: backgroundColor, ...compOverrides.root.styles },
      ...compOverrides.root.props,
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
        import_material3.Toolbar,
        {
          sx: compOverrides.toolbar.styles,
          ...compOverrides.toolbar.props,
          children
        }
      )
    }
  );
};
NavigationBar.getComponents = () => {
  return components11;
};
NavigationBar.propTypes = {
  /**
   * Background color of this component
   */
  backgroundColor: import_prop_types11.default.string,
  /**
   * Children for the primary element
   */
  children: import_prop_types11.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types11.default.objectOf(
    import_prop_types11.default.shape({
      props: import_prop_types11.default.any,
      styles: import_prop_types11.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types11.default.any
};

// src/NavigationDrawer/NavigationDrawer.js
var import_react2 = require("react");
var import_prop_types12 = __toESM(require("prop-types"));
var import_List = __toESM(require("@mui/material/List"));
var import_ListItem = __toESM(require("@mui/material/ListItem"));
var import_ListItemButton = __toESM(require("@mui/material/ListItemButton"));
var import_ListItemText = __toESM(require("@mui/material/ListItemText"));
var import_Typography7 = __toESM(require("@mui/material/Typography"));
var import_jsx_runtime12 = require("react/jsx-runtime");
var defaultStyles12 = {
  root: {
    height: "100%",
    maxWidth: "380px",
    overflow: "clip"
  },
  navDrawerSticky: {
    position: "sticky",
    top: "60px"
  },
  title: {
    paddingLeft: "30px",
    fontWeight: "bold"
  },
  navDrawer: {
    fontSize: "1.2rem",
    paddingTop: "1.5rem"
  },
  navItem: {
    padding: "16px 32px",
    "&:hover": {
      backgroundColor: "#E2E7EE"
    }
  },
  navText: {
    "& span": {
      fontWeight: "bold"
    }
  },
  line: {
    width: "100%",
    borderBottom: "1px solid lightgrey"
  }
};
var components12 = [
  "root",
  "navDrawerSticky",
  "title",
  "navDrawer",
  "navItem",
  "navText",
  "line"
];
var NavigationDrawer = ({ title = "Page Navigation", items = [], menuClick, activeKey, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components12, defaultStyles12, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
    "div",
    {
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)(
        "div",
        {
          style: compOverrides.navDrawerSticky.styles,
          ...compOverrides.navDrawerSticky.props,
          children: [
            title && /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
              import_Typography7.default,
              {
                variant: "h2",
                sx: compOverrides.title.styles,
                ...compOverrides.title.props,
                children: title
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
              import_List.default,
              {
                className: "flex-column",
                sx: compOverrides.navDrawer.styles,
                ...compOverrides.navDrawer.props,
                children: items.map((item, index) => {
                  if (item.hidden) return;
                  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(import_ListItem.default, { disablePadding: true, disableGutters: true, children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
                    import_ListItemButton.default,
                    {
                      onClick: (e) => {
                        menuClick(item.key, e);
                      },
                      disabled: item.disabled,
                      disableGutters: true,
                      divider: true,
                      sx: compOverrides.navItem.styles,
                      ...compOverrides.navItem.props,
                      children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
                        import_ListItemText.default,
                        {
                          sx: compOverrides.navText.styles,
                          ...compOverrides.navText.props,
                          children: item.label
                        }
                      )
                    }
                  ) }, item.key);
                })
              }
            )
          ]
        }
      )
    }
  );
};
NavigationDrawer.getComponents = () => {
  return components12;
};
NavigationDrawer.propTypes = {
  /**
   * The title of this navigation drawer, that is displayed above it
   */
  title: import_prop_types12.default.string,
  /**
   * The array of navigation options
   */
  items: import_prop_types12.default.arrayOf(import_prop_types12.default.shape({ key: import_prop_types12.default.string, label: import_prop_types12.default.string, disabled: import_prop_types12.default.bool })),
  /**
   * Callback function for when an option is selected
   */
  menuClick: import_prop_types12.default.func,
  /**
   * The key of the option that should display as being active
   */
  activeKey: import_prop_types12.default.string,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types12.default.objectOf(
    import_prop_types12.default.shape({
      props: import_prop_types12.default.any,
      styles: import_prop_types12.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types12.default.any
};

// src/PipelineBlock/PipelineBlock.js
var import_prop_types13 = __toESM(require("prop-types"));
var import_react3 = require("react");
var import_Typography8 = __toESM(require("@mui/material/Typography"));
var import_MenuItem = __toESM(require("@mui/material/MenuItem"));
var import_md2 = require("react-icons/md");
var import_jsx_runtime13 = require("react/jsx-runtime");
var defaultStyles13 = {
  root: {
    borderRadius: "6px",
    backgroundColor: "#27465A",
    width: "100%",
    maxWidth: "300px",
    minWidth: "200px",
    color: "white"
  },
  head: {
    display: "flex",
    borderRadius: "6px 6px 0 0",
    backgroundColor: "black",
    padding: "20px",
    fontStyle: "italic"
  },
  headText: {
    flexGrow: 1
  },
  dropdownButton: {
    color: "inherit",
    padding: "0",
    minWidth: "30px"
  },
  icon: {
    fontSize: "1.2rem",
    float: "right"
  },
  body: {
    padding: "20px",
    height: "100px"
  }
};
var components13 = [
  "root",
  "head",
  "headText",
  "dropdownButton",
  "icon",
  "body"
];
var PipelineBlock = ({
  info = {},
  name,
  active = false,
  inPipeline = false,
  activeMenuOptions,
  activeOnClick,
  inactiveMenuOptions,
  inactiveOnClick,
  addedMenuOptions,
  addedOnClick,
  overrides = {},
  ...props
}) => {
  const typeColors = {
    cohort: "#2D6497",
    input: "#2D6497",
    dataset: "#2D6497",
    model: "#4B3682",
    tool: "#2A7A82",
    output: "#C8CF66"
  };
  defaultStyles13.head.backgroundColor = info?.type ? typeColors[info?.type.toLowerCase()] : "black";
  const compOverrides = componentSpread(components13, defaultStyles13, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(
    "div",
    {
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(
          "div",
          {
            style: compOverrides.head.styles,
            ...compOverrides.head.props,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
                import_Typography8.default,
                {
                  style: compOverrides.headText.styles,
                  ...compOverrides.headText.props,
                  children: modifyName(info?.type)
                }
              ),
              !active && !inPipeline && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
                Dropdown,
                {
                  variant: "text",
                  noArrow: true,
                  overrides: { button: { styles: compOverrides.dropdownButton.styles, props: compOverrides.dropdownButton.props } },
                  title: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
                    import_md2.MdAdd,
                    {
                      style: compOverrides.icon.styles,
                      ...compOverrides.icon.props
                    }
                  ),
                  onClick: (e) => inactiveOnClick && inactiveOnClick(e, info),
                  children: inactiveMenuOptions
                }
              ),
              active && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
                Dropdown,
                {
                  variant: "text",
                  noArrow: true,
                  overrides: { button: { styles: compOverrides.dropdownButton.styles, props: compOverrides.dropdownButton.props } },
                  title: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
                    import_md2.MdCheck,
                    {
                      style: compOverrides.icon.styles,
                      ...compOverrides.icon.props
                    }
                  ),
                  onClick: (e) => activeOnClick && activeOnClick(e, info),
                  children: activeMenuOptions
                }
              ),
              inPipeline && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
                Dropdown,
                {
                  variant: "text",
                  noArrow: true,
                  overrides: { button: { styles: compOverrides.dropdownButton.styles, props: compOverrides.dropdownButton.props } },
                  title: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
                    import_md2.MdRemove,
                    {
                      style: compOverrides.icon.styles,
                      ...compOverrides.icon.props
                    }
                  ),
                  onClick: (e) => addedOnClick && addedOnClick(e, info),
                  children: addedMenuOptions
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          "div",
          {
            style: compOverrides.body.styles,
            ...compOverrides.body.props,
            children: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(import_Typography8.default, { children: name || info.name })
          }
        )
      ]
    }
  );
};
PipelineBlock.getComponents = () => {
  return components13;
};
PipelineBlock.propTypes = {
  /**
   * Information about what this block represents
   */
  info: import_prop_types13.default.shape({
    type: import_prop_types13.default.string,
    name: import_prop_types13.default.string,
    guid: import_prop_types13.default.string
  }),
  /**
   * True if block is actively in a pipeline, false if it can be added to one
   */
  active: import_prop_types13.default.bool,
  /**
   * A list of menu options for the active-state button
   */
  activeMenuOptions: import_prop_types13.default.node,
  /**
   * A list of menu options for the inactive-state button
   */
  inactiveMenuOptions: import_prop_types13.default.node,
  /**
   * Click handler for the active-state button
   */
  activeOnClick: import_prop_types13.default.func,
  /**
   * Click handler for the inactive-state button
   */
  inactiveOnClick: import_prop_types13.default.func,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types13.default.objectOf(
    import_prop_types13.default.shape({
      props: import_prop_types13.default.any,
      styles: import_prop_types13.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types13.default.any
};

// src/PipelineStatus/PipelineStatus.js
var import_prop_types14 = __toESM(require("prop-types"));
var import_react4 = require("react");
var import_Typography9 = __toESM(require("@mui/material/Typography"));
var import_MenuItem2 = __toESM(require("@mui/material/MenuItem"));
var import_md3 = require("react-icons/md");
var import_jsx_runtime14 = require("react/jsx-runtime");
var defaultStyles14 = {
  root: {
    display: "flex",
    width: "100%",
    maxWidth: "334px",
    minWidth: "200px",
    minHeight: "197px",
    color: "white"
  },
  side: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    width: "55px",
    minWidth: "55px",
    borderRadius: "6px 0 0 6px",
    paddingBottom: "10px",
    backgroundColor: "black"
  },
  body: {
    flexGrow: "1",
    padding: "20px",
    borderRadius: "0 6px 6px 0",
    backgroundColor: "#27465A"
  },
  pipelineTitle: {
    marginBottom: "15px",
    fontWeight: "bold"
  },
  statusArea: {
    marginTop: "15px"
  },
  statusLabel: {
    width: "80px"
  },
  statusValue: {},
  icon: {
    fontSize: "1.2rem"
  }
};
var components14 = [
  "root",
  "side",
  "body",
  "pipelineTitle",
  "statusArea",
  "statusLabel",
  "statusValue",
  "icon"
];
var PipelineStatus = ({
  statusInfo = {},
  pipelineTitle = "",
  startOnClick,
  stopOnClick,
  refreshOnClick,
  overrides = {},
  ...props
}) => {
  statusInfo = {
    status: "Not Run",
    started: "-------------",
    finished: "-------------",
    duration: "-------------",
    ...statusInfo
  };
  const statusBodyColors = {
    completed: "#2A4840",
    "initiated": "#584D39",
    "in progress": "#584D39",
    "stopping": "#584D39",
    "not run": "#27465A",
    error: "#3B3341"
  };
  const statusSideColors = {
    completed: "#698D60",
    "initiated": "#DC994F",
    "in progress": "#DC994F",
    "stopping": "#DC994F",
    "not run": "#678191",
    error: "#463D4A"
  };
  const activeStates = ["initiated", "in progress", "stopping"];
  const stoppableStates = ["initiated", "in progress"];
  defaultStyles14.body.backgroundColor = statusInfo?.status ? statusBodyColors[statusInfo?.status.toLowerCase()] : "black";
  defaultStyles14.side.backgroundColor = statusInfo?.status ? statusSideColors[statusInfo?.status.toLowerCase()] : "grey";
  const compOverrides = componentSpread(components14, defaultStyles14, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
    "div",
    {
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
          "div",
          {
            style: compOverrides.side.styles,
            ...compOverrides.side.props,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                Button,
                {
                  variant: "text",
                  color: "white",
                  onClick: startOnClick,
                  disabled: activeStates.includes(statusInfo?.status.toLowerCase()),
                  children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                    import_md3.MdPlayArrow,
                    {
                      style: compOverrides.icon.styles,
                      ...compOverrides.icon.props
                    }
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                Button,
                {
                  variant: "text",
                  color: "white",
                  onClick: refreshOnClick,
                  disabled: !(statusInfo?.status.toLowerCase() === "in progress"),
                  children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                    import_md3.MdOutlineRefresh,
                    {
                      style: compOverrides.icon.styles,
                      ...compOverrides.icon.props
                    }
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                Button,
                {
                  variant: "text",
                  color: "white",
                  onClick: stopOnClick,
                  disabled: !stoppableStates.includes(statusInfo?.status.toLowerCase()),
                  children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                    import_md3.MdStop,
                    {
                      style: compOverrides.icon.styles,
                      ...compOverrides.icon.props
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
          "div",
          {
            style: compOverrides.body.styles,
            ...compOverrides.body.props,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                import_Typography9.default,
                {
                  style: compOverrides.pipelineTitle.styles,
                  ...compOverrides.pipelineTitle.props,
                  children: pipelineTitle
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(import_Typography9.default, { variant: "body2", children: "STATUS" }),
              /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                "table",
                {
                  style: compOverrides.statusArea.styles,
                  ...compOverrides.statusArea.props,
                  children: /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("tbody", { children: [
                    /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("tr", { children: [
                      /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("td", { children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                        import_Typography9.default,
                        {
                          variant: "body2",
                          style: compOverrides.statusLabel.styles,
                          ...compOverrides.statusLabel.props,
                          children: "Status"
                        }
                      ) }),
                      /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("td", { children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                        import_Typography9.default,
                        {
                          variant: "body2",
                          style: compOverrides.statusValue.styles,
                          ...compOverrides.statusValue.props,
                          children: statusInfo.status
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("tr", { children: [
                      /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("td", { children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                        import_Typography9.default,
                        {
                          variant: "body2",
                          style: compOverrides.statusLabel.styles,
                          ...compOverrides.statusLabel.props,
                          children: "Started"
                        }
                      ) }),
                      /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("td", { children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                        import_Typography9.default,
                        {
                          variant: "body2",
                          style: compOverrides.statusValue.styles,
                          ...compOverrides.statusValue.props,
                          children: statusInfo.started
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("tr", { children: [
                      /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("td", { children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                        import_Typography9.default,
                        {
                          variant: "body2",
                          style: compOverrides.statusLabel.styles,
                          ...compOverrides.statusLabel.props,
                          children: "Finished"
                        }
                      ) }),
                      /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("td", { children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                        import_Typography9.default,
                        {
                          variant: "body2",
                          style: compOverrides.statusValue.styles,
                          ...compOverrides.statusValue.props,
                          children: statusInfo.finished
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("tr", { children: [
                      /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("td", { children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                        import_Typography9.default,
                        {
                          variant: "body2",
                          style: compOverrides.statusLabel.styles,
                          ...compOverrides.statusLabel.props,
                          children: "Duration"
                        }
                      ) }),
                      /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("td", { children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                        import_Typography9.default,
                        {
                          variant: "body2",
                          style: compOverrides.statusValue.styles,
                          ...compOverrides.statusValue.props,
                          children: statusInfo.duration
                        }
                      ) })
                    ] })
                  ] })
                }
              )
            ]
          }
        )
      ]
    }
  );
};
PipelineStatus.getComponents = () => {
  return components14;
};
PipelineStatus.propTypes = {
  /**
   * Information about the status of a pipeline
   */
  statusInfo: import_prop_types14.default.shape({
    type: import_prop_types14.default.string,
    name: import_prop_types14.default.string,
    guid: import_prop_types14.default.string
  }),
  /**
   * The name of the relevant pipeline
   */
  pipelineTitle: import_prop_types14.default.string,
  /**
   * Click handler for the start button
   */
  startOnClick: import_prop_types14.default.func,
  /**
   * Click handler for the refresh button
   */
  refreshOnClick: import_prop_types14.default.func,
  /**
   * Click handler for the stop button
   */
  stopOnClick: import_prop_types14.default.func,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types14.default.objectOf(
    import_prop_types14.default.shape({
      props: import_prop_types14.default.any,
      styles: import_prop_types14.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types14.default.any
};

// src/ProgressBar/ProgressBar.js
var import_prop_types15 = __toESM(require("prop-types"));
var import_LinearProgress = __toESM(require("@mui/material/LinearProgress"));
var import_jsx_runtime15 = require("react/jsx-runtime");
var defaultStyles15 = {
  root: {
    width: "100%"
  }
};
var components15 = [
  "root"
];
var ProgressBar = ({ variant = "determinate", barColor = "#FFAF13", barBgColor = "#A7CAED", value = 0, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components15, defaultStyles15, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
    import_LinearProgress.default,
    {
      variant,
      value,
      sx: {
        backgroundColor: barBgColor,
        "& .MuiLinearProgress-bar": {
          backgroundColor: barColor
        }
      },
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props
    }
  );
};
ProgressBar.getComponents = () => {
  return components15;
};
ProgressBar.propTypes = {
  /**
   * What type of Linear Progress Bar to use
   */
  variant: import_prop_types15.default.string,
  /**
   * The color of the bar foreground
   */
  barColor: import_prop_types15.default.string,
  /**
   * The color of the bar background
   */
  barBgColor: import_prop_types15.default.string,
  /**
   * How far along the bar should be progressed to
   */
  value: import_prop_types15.default.number,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types15.default.objectOf(
    import_prop_types15.default.shape({
      props: import_prop_types15.default.any,
      styles: import_prop_types15.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types15.default.any
};

// src/SectionHeader/SectionHeader.js
var import_prop_types16 = __toESM(require("prop-types"));
var import_Typography10 = __toESM(require("@mui/material/Typography"));
var import_jsx_runtime16 = require("react/jsx-runtime");
var defaultStyles16 = {
  root: {
    marginBottom: "1.5rem"
  }
};
var components16 = [
  "root"
];
var SectionHeader = ({ children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components16, defaultStyles16, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
    import_Typography10.default,
    {
      variant: "h2",
      sx: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
SectionHeader.getComponents = () => {
  return components16;
};
SectionHeader.propTypes = {
  /**
   * Children for the primary element
   */
  children: import_prop_types16.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types16.default.objectOf(
    import_prop_types16.default.shape({
      props: import_prop_types16.default.any,
      styles: import_prop_types16.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types16.default.any
};

// src/SectionDescription/SectionDescription.js
var import_prop_types17 = __toESM(require("prop-types"));
var import_Typography11 = __toESM(require("@mui/material/Typography"));
var import_jsx_runtime17 = require("react/jsx-runtime");
var defaultStyles17 = {
  root: {
    marginBottom: "30px"
  }
};
var components17 = [
  "root"
];
var SectionDescription = ({ children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components17, defaultStyles17, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
    import_Typography11.default,
    {
      component: "span",
      sx: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
SectionDescription.getComponents = () => {
  return components17;
};
SectionDescription.propTypes = {
  /**
   * Children for the primary element
   */
  children: import_prop_types17.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types17.default.objectOf(
    import_prop_types17.default.shape({
      props: import_prop_types17.default.any,
      styles: import_prop_types17.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types17.default.any
};

// src/ImageRow/ImageRow.js
var import_prop_types18 = __toESM(require("prop-types"));
var import_ImageList = __toESM(require("@mui/material/ImageList"));
var import_ImageListItem = __toESM(require("@mui/material/ImageListItem"));
var import_ImageListItemBar = __toESM(require("@mui/material/ImageListItemBar"));
var import_jsx_runtime18 = require("react/jsx-runtime");
var defaultStyles18 = {
  root: {
    width: "100%"
  },
  imageWrap: {
    height: "100%",
    minWidth: "330px",
    marginTop: "20px",
    marginBottom: "10px"
  },
  image: {
    width: "100%",
    height: "auto"
  }
};
var components18 = [
  "root",
  "imageWrap",
  "image"
];
var ImageRow = ({ images = [], prefix = "", overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components18, defaultStyles18, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
    import_ImageList.default,
    {
      sx: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children: images.map((image, index) => {
        let img = image.url || image;
        return /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)(import_ImageListItem.default, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
            "img",
            {
              src: img,
              style: compOverrides.image.styles,
              ...compOverrides.image.props,
              alt: image?.title || image?.alt || image
            }
          ),
          image?.title && /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
            import_ImageListItemBar.default,
            {
              title: image.title,
              subtitle: image.description,
              position: "below"
            }
          )
        ] }, prefix + img);
      })
    }
  );
};
ImageRow.getComponents = () => {
  return components18;
};
ImageRow.propTypes = {
  /**
   * Array of images or image urls to display
   */
  images: import_prop_types18.default.arrayOf(import_prop_types18.default.oneOfType([import_prop_types18.default.string, import_prop_types18.default.shape({ url: import_prop_types18.default.string })])),
  /**
   * Children for the primary element
   */
  prefix: import_prop_types18.default.string,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types18.default.objectOf(
    import_prop_types18.default.shape({
      props: import_prop_types18.default.any,
      styles: import_prop_types18.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types18.default.any
};

// src/ItemDescription/ItemDescription.js
var import_prop_types19 = __toESM(require("prop-types"));
var import_Typography12 = __toESM(require("@mui/material/Typography"));
var import_jsx_runtime19 = require("react/jsx-runtime");
var defaultStyles19 = {
  root: {}
};
var components19 = [
  "root"
];
var ItemDescription = ({ children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components19, defaultStyles19, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
    import_Typography12.default,
    {
      variant: "body1",
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
ItemDescription.getComponents = () => {
  return components19;
};
ItemDescription.propTypes = {
  /**
   * Children for the primary element
   */
  children: import_prop_types19.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types19.default.objectOf(
    import_prop_types19.default.shape({
      props: import_prop_types19.default.any,
      styles: import_prop_types19.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types19.default.any
};

// src/ItemHeader/ItemHeader.js
var import_prop_types20 = __toESM(require("prop-types"));
var import_Typography13 = __toESM(require("@mui/material/Typography"));
var import_jsx_runtime20 = require("react/jsx-runtime");
var defaultStyles20 = {
  root: {
    //paddingBottom: '0px',
    //margin: '0px',
  }
};
var components20 = [
  "root"
];
var ItemHeader = ({ children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components20, defaultStyles20, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
    import_Typography13.default,
    {
      variant: "h4",
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
ItemHeader.getComponents = () => {
  return components20;
};
ItemHeader.propTypes = {
  /**
   * Children for the primary element
   */
  children: import_prop_types20.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types20.default.objectOf(
    import_prop_types20.default.shape({
      props: import_prop_types20.default.any,
      styles: import_prop_types20.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types20.default.any
};

// src/Tabs/Tabs.js
var import_prop_types21 = __toESM(require("prop-types"));
var import_TabList = __toESM(require("@mui/lab/TabList"));
var import_material4 = require("@mui/material");
var import_Tab = __toESM(require("@mui/material/Tab"));
var import_jsx_runtime21 = require("react/jsx-runtime");
var defaultStyles21 = {
  root: {
    width: "100%"
  },
  tab: {
    fontSize: "1rem",
    padding: "20px"
  },
  inactiveTab: {
    borderBottom: "solid 4px rgba(0, 0, 0, 0.3)"
  },
  activeTab: {
    fontWeight: "bold !important",
    borderBottom: "solid 4px rgba(0, 0, 0, 0)"
  }
};
var components21 = [
  "root",
  "tab",
  "activeTab",
  "inactiveTab"
];
var Tabs = ({ tabNames = [], tabKey, setTabKey, closable, children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components21, defaultStyles21, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
    import_material4.Tabs,
    {
      value: tabKey,
      onChange: setTabKey ? (e, newKey) => {
        setTabKey(newKey);
      } : null,
      variant: !closable ? "fullWidth" : null,
      TabIndicatorProps: {
        sx: {
          height: "4px"
        }
      },
      sx: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children: tabNames.map((tabInfo, index) => {
        if (tabInfo?.hidden) return;
        let tabName = tabInfo.name || tabInfo;
        let tabValue = tabInfo.value || tabName;
        let activeStyles = tabKey === tabValue ? compOverrides.activeTab.styles : compOverrides.inactiveTab.styles;
        let disabled = tabInfo?.disabled || false;
        return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
          import_Tab.default,
          {
            label: tabName,
            value: tabValue,
            sx: { ...compOverrides.tab.styles, ...activeStyles },
            ...compOverrides.tab.props,
            disabled
          },
          tabValue
        );
      })
    }
  );
};
Tabs.getComponents = () => {
  return components21;
};
Tabs.propTypes = {
  /**
   * An array of all tab keys
   */
  tabNames: import_prop_types21.default.arrayOf(import_prop_types21.default.oneOfType([import_prop_types21.default.string, import_prop_types21.default.object])),
  /**
   * The key for which tab to focus on actively
   */
  tabKey: import_prop_types21.default.string,
  /**
   * Setter function for the tab key
   */
  setTabKey: import_prop_types21.default.func,
  /**
   * True to make the tabs closable by the user, and not full-width
   */
  closable: import_prop_types21.default.bool,
  /**
   * Children for the primary element
   */
  children: import_prop_types21.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types21.default.objectOf(
    import_prop_types21.default.shape({
      props: import_prop_types21.default.any,
      styles: import_prop_types21.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types21.default.any
};

// src/TabsContainer/TabsContainer.js
var import_prop_types22 = __toESM(require("prop-types"));
var import_TabContext = __toESM(require("@mui/lab/TabContext"));
var import_jsx_runtime22 = require("react/jsx-runtime");
var defaultStyles22 = {
  root: {
    width: "100%",
    backgroundColor: "white"
  }
};
var components22 = [
  "root"
];
var TabsContainer = ({ tabKey, children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components22, defaultStyles22, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
    import_TabContext.default,
    {
      value: tabKey,
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
TabsContainer.getComponents = () => {
  return components22;
};
TabsContainer.propTypes = {
  /**
   * The key for which tab to focus on
   */
  tabKey: import_prop_types22.default.string,
  /**
   * Children for the primary element
   */
  children: import_prop_types22.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types22.default.objectOf(
    import_prop_types22.default.shape({
      props: import_prop_types22.default.any,
      styles: import_prop_types22.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types22.default.any
};

// src/TabPane/TabPane.js
var import_prop_types23 = __toESM(require("prop-types"));
var import_react5 = require("react");
var import_TabPanel = __toESM(require("@mui/lab/TabPanel"));
var import_jsx_runtime23 = require("react/jsx-runtime");
var defaultStyles23 = {
  root: {
    width: "100%"
  }
};
var components23 = [
  "root"
];
var TabPane = ({ eventKey, children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components23, defaultStyles23, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
    import_TabPanel.default,
    {
      value: eventKey,
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children
    }
  );
};
TabPane.getComponents = () => {
  return components23;
};
TabPane.propTypes = {
  /**
   * The key of the option that should display as being active
   */
  eventKey: import_prop_types23.default.string,
  /**
   * Children for the primary element
   */
  children: import_prop_types23.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types23.default.objectOf(
    import_prop_types23.default.shape({
      props: import_prop_types23.default.any,
      styles: import_prop_types23.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types23.default.any
};

// src/TextField/TextField.js
var import_prop_types24 = __toESM(require("prop-types"));
var import_material5 = require("@mui/material");
var import_InputAdornment = __toESM(require("@mui/material/InputAdornment"));
var import_md4 = require("react-icons/md");
var import_jsx_runtime24 = require("react/jsx-runtime");
var defaultStyles24 = {
  root: {
    background: "white"
  },
  itemHeader: {
    color: "#333333",
    margin: "10px 0 0 0"
  },
  endAdornment: {},
  warningIcon: {
    color: "#d32f2f",
    fontSize: "20px"
  }
};
var components24 = [
  "root",
  "itemHeader",
  "endAdornment",
  "warningIcon"
];
var TextField = ({ variant = "outlined", label = false, isInnerLabel = false, ariaLabel, maxLength, children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components24, defaultStyles24, overrides, props);
  const inputLabelProps = {};
  if (!label || !isInnerLabel) {
    inputLabelProps["shrink"] = false;
  }
  if (!isInnerLabel) {
    inputLabelProps["required"] = false;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)(import_jsx_runtime24.Fragment, { children: [
    label && !isInnerLabel && /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)(
      ItemHeader,
      {
        sx: compOverrides.itemHeader.styles,
        ...compOverrides.itemHeader.props,
        children: [
          label,
          " ",
          props?.required && /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(import_jsx_runtime24.Fragment, { children: "*" })
        ]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
      import_material5.TextField,
      {
        sx: compOverrides.root.styles,
        variant,
        label: isInnerLabel && label,
        fullWidth: true,
        slotProps: {
          input: {
            endAdornment: props.error && /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
              import_InputAdornment.default,
              {
                position: "end",
                style: compOverrides.endAdornment.styles,
                ...compOverrides.endAdornment.props,
                children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
                  import_md4.MdOutlineWarningAmber,
                  {
                    style: compOverrides.warningIcon.styles,
                    ...compOverrides.warningIcon.props
                  }
                )
              }
            ),
            "aria-label": ariaLabel,
            ...props.InputProps
          },
          htmlInput: {
            maxLength,
            ...props.inputProps
          },
          inputLabel: inputLabelProps,
          ...props.slotProps
        },
        ...compOverrides.root.props,
        ...props,
        children
      }
    )
  ] });
};
TextField.getComponents = () => {
  return components24;
};
TextField.propTypes = {
  /**
   * Variant type for this button
   */
  variant: import_prop_types24.default.string,
  /**
   * Label for this field
   */
  label: import_prop_types24.default.oneOfType([
    import_prop_types24.default.string,
    import_prop_types24.default.bool
  ]),
  /**
   * Should the label by the type that is inside the field and shrinks when active?
   */
  isInnerLabel: import_prop_types24.default.bool,
  /**
   * Accessability aria label
   */
  ariaLabel: import_prop_types24.default.string,
  /**
   * Maximum number of characters this text field will allow
   */
  maxLength: import_prop_types24.default.oneOfType([
    import_prop_types24.default.string,
    import_prop_types24.default.number
  ]),
  /**
   * Children for the primary element
   */
  children: import_prop_types24.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types24.default.objectOf(
    import_prop_types24.default.shape({
      props: import_prop_types24.default.any,
      styles: import_prop_types24.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types24.default.any
};

// src/ToggleIcon/ToggleIcon.js
var import_prop_types25 = __toESM(require("prop-types"));
var import_react6 = require("react");
var import_material6 = require("@mui/material");
var import_jsx_runtime25 = require("react/jsx-runtime");
var defaultStyles25 = {
  root: {
    display: "flex",
    width: "100%",
    cursor: "pointer"
  },
  activeToggle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    aspectRatio: "1 / 1",
    height: "100%",
    maxWidth: "230px",
    maxHeight: "230px",
    padding: "8%",
    borderRadius: "50%",
    fontSize: "calc(1em + 4vmin)",
    borderWidth: "6px",
    borderStyle: "solid",
    borderColor: "#02598C",
    backgroundColor: "#02598C",
    color: "#FFFFFF"
  },
  inactiveToggle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    aspectRatio: "1 / 1",
    height: "100%",
    maxWidth: "230px",
    maxHeight: "230px",
    padding: "8%",
    borderRadius: "50%",
    fontSize: "calc(1em + 4vmin)",
    borderWidth: "6px",
    borderStyle: "solid",
    borderColor: "#02598C",
    backgroundColor: "#FFFFFF",
    color: "#02598C"
  },
  label: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "15px",
    color: "#143340",
    fontSize: "18px",
    fontWeight: "bold",
    textWrap: "nowrap",
    userSelect: "none"
  }
};
var components25 = [
  "root",
  "activeToggle",
  "inactiveToggle",
  "label"
];
var ToggleIcon = ({ icon, color, active = false, onClick, children, overrides = {}, ...props }) => {
  const compOverrides = componentSpread(components25, defaultStyles25, overrides, props);
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsxs)(
    "div",
    {
      onClick,
      style: compOverrides.root.styles,
      ...compOverrides.root.props,
      ...props,
      children: [
        active && /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
          "div",
          {
            style: {
              ...compOverrides.activeToggle.styles,
              ...{
                borderColor: overrides.activeToggle?.styles?.borderColor || color || compOverrides.activeToggle.styles.borderColor,
                backgroundColor: overrides.activeToggle?.styles?.backgroundColor || color || compOverrides.activeToggle.styles.backgroundColor
              }
            },
            ...compOverrides.activeToggle.props,
            children: icon
          }
        ),
        !active && /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
          "div",
          {
            style: {
              ...compOverrides.inactiveToggle.styles,
              ...{
                borderColor: overrides.inactiveToggle?.styles?.borderColor || color || compOverrides.inactiveToggle.styles.borderColor,
                color: overrides.inactiveToggle?.styles?.color || color || compOverrides.inactiveToggle.styles.color
              }
            },
            ...compOverrides.inactiveToggle.props,
            children: icon
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
          "div",
          {
            style: compOverrides.label.styles,
            ...compOverrides.label.props,
            children
          }
        )
      ]
    }
  );
};
ToggleIcon.getComponents = () => {
  return components25;
};
ToggleIcon.propTypes = {
  /**
   * New icon for this button
   */
  icon: import_prop_types25.default.any,
  /**
   * Color type for this button
   */
  color: import_prop_types25.default.string,
  /**
   * Active toggle for this button
   */
  active: import_prop_types25.default.bool,
  /**
   * onClick callback function
   */
  onClick: import_prop_types25.default.func,
  /**
   * Children for the primary element
   */
  children: import_prop_types25.default.node,
  /**
   * Any overrides to be propogated to the respective component. 
   */
  overrides: import_prop_types25.default.objectOf(
    import_prop_types25.default.shape({
      props: import_prop_types25.default.any,
      styles: import_prop_types25.default.any
    })
  ),
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types25.default.any
};

// src/ProvideTheme/ProvideTheme.js
var import_prop_types26 = __toESM(require("prop-types"));
var import_styles2 = require("@mui/material/styles");
var import_CssBaseline = __toESM(require("@mui/material/CssBaseline"));
var import_jsx_runtime26 = require("react/jsx-runtime");
var ProvideTheme = ({ themeType = "default", children, ...props }) => {
  let selectedTheme;
  switch (themeType) {
    case "default":
    case "light":
      selectedTheme = RapidsAgentTheme;
      break;
    case "dark":
      selectedTheme = RapidsAgentDarkTheme;
      break;
    case "challenge":
      selectedTheme = RapidsChallengeTheme;
      break;
    default:
      selectedTheme = RapidsAgentTheme;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)(import_styles2.ThemeProvider, { theme: selectedTheme, children: [
    /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(import_CssBaseline.default, { enableColorScheme: true }),
    children
  ] });
};
ProvideTheme.propTypes = {
  /**
   * Theme selector. 'default' or 'dark.
   */
  themeType: import_prop_types26.default.string,
  /**
   * Children for the primary element
   */
  children: import_prop_types26.default.node,
  /**
   * Any additional properties to be propogated to the primary element
   */
  props: import_prop_types26.default.any
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AttributeList,
  Button,
  CataloguePageDescription,
  CataloguePageTitle,
  DataGrid,
  Dropdown,
  HeroImage,
  ImageRow,
  ItemDescription,
  ItemHeader,
  NavigationBar,
  NavigationDrawer,
  PipelineBlock,
  PipelineStatus,
  ProgressBar,
  ProvideTheme,
  RapidsAgentDarkTheme,
  RapidsAgentTheme,
  RapidsChallengeTheme,
  SectionDescription,
  SectionHeader,
  TabPane,
  Tabs,
  TabsContainer,
  TextField,
  ToggleIcon
});
